import { render, staticRenderFns } from "./modalEditMerchandiseBrand.vue?vue&type=template&id=77cab813&"
import script from "./modalEditMerchandiseBrand.vue?vue&type=script&lang=js&"
export * from "./modalEditMerchandiseBrand.vue?vue&type=script&lang=js&"
import style0 from "./modalEditMerchandiseBrand.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports